import request from "@/utils/request";
import qs from "qs";

/**
 * 创建角色【ok】
 * @param params
 * @returns {*}
 */
export function createRole(params) {
  return request.post("/role/editRole", qs.stringify(params));
}

/**
 * 编辑角色权限【ok】
 * @param params
 * @returns {*}
 */
export function updateRolePermission(params) {
  return request.post("/role/editRoleMenu", qs.stringify(params));
}
/**
 * 查询角色【ok】
 * @param params
 * @returns {*}
 */
export function getRoleList(params) {
  return request({
    url: "/role/getRoleTree",
    method: "get",
    params
  });
}

/**
 * 查询级联角色【ok】
 * @param params
 * @returns {*}
 */
export function getCascadeRole(params) {
  return request({
    url: "/role/getCascadeRole",
    method: "get",
    params
  });
}

/**
 * 查询角色权限数【ok】
 * @param params
 */
export function getRolePermissionTree(params) {
  return request({
    url: "/role/getRoleMenuTree",
    method: "get",
    params
  });
}

/**
 * 查询角色树【未使用 】
 * @param params
 * @returns {*}
 */
export function getRoleTree(params) {
  return request({
    url: "/role/getRoleTree",
    method: "get",
    params
  });
}
